import {createSelector} from 'reselect';
import isempty from 'lodash/isEmpty';
import {get} from 'lodash';

import guardedSelector from '../utils/guardedSelector';
import {getSleeps, getListingHouseRules} from './listing';
import {getLocaleJS} from './system';
import {getTranslations} from './store';

const getBinaryHouseRules = createSelector(
    [getListingHouseRules],
    (listingHouseRules = {}) => {
        const {events, smoking, pets, children} = listingHouseRules;
        return [events, smoking, pets, children].filter((rule) => rule);
    }
);

const getValueHouseRules = createSelector(
    [getSleeps, getListingHouseRules],
    (sleeps, listingHouseRules = {}) => {
        const {maxOccupancy, minimumAge} = listingHouseRules;
        const valueRules = [];

        if (minimumAge) {
            valueRules.push({
                value: minimumAge.minimumAge,
                label: minimumAge.label,
                note: minimumAge.note
            });
        }

        if (maxOccupancy) {
            valueRules.push({
                value: sleeps,
                label: maxOccupancy.label,
                note: maxOccupancy.note
            });
        }

        return valueRules;
    }
);

const getCustomHouseRules = createSelector(
    [getListingHouseRules],
    (listingHouseRules = {}) => {
        return listingHouseRules.customRules || [];
    }
);

const getHouseRules = guardedSelector(
    'getHouseRules',
    createSelector(
        [
            getBinaryHouseRules,
            getValueHouseRules,
            getCustomHouseRules,
            getListingHouseRules,
            getLocaleJS,
            getTranslations
        ],
        (binaryRules, valueRules, customRules, listingHouseRules, locale, translations) => {
            const checkInTime = get(listingHouseRules, 'checkInTime');

            const checkOutTime = get(listingHouseRules, 'checkOutTime');

            // if property is using legacy, unstructured house rules we can short circuit
            if (isempty(listingHouseRules)) {
                return {
                    showHouseRules: !!(checkInTime && checkOutTime),
                    checkIn: checkInTime,
                    checkOut: checkOutTime,
                    labels: translations
                };
            }

            const showHouseRules = !!(
                checkInTime ||
                checkOutTime ||
                listingHouseRules.minimumAge ||
                listingHouseRules.maxOccupancy ||
                listingHouseRules.standardRules ||
                listingHouseRules.customRules
            );

            const showHouseRulesV2 =
                listingHouseRules.childrenRule &&
                listingHouseRules.childrenRule.displayText &&
                listingHouseRules.petsRule &&
                listingHouseRules.petsRule.displayText &&
                listingHouseRules.eventsRule &&
                listingHouseRules.eventsRule.displayText &&
                listingHouseRules.smokingRule &&
                listingHouseRules.smokingRule.displayText;

            return {
                showHouseRules,
                showHouseRulesV2,
                checkIn: checkInTime,
                checkOut: checkOutTime,
                binaryRules,
                valueRules,
                customRules,
                listingHouseRules,
                labels: translations
            };
        }
    )
);
/* eslint-enable complexity */

export default getHouseRules;
export {getHouseRules, getBinaryHouseRules, getValueHouseRules, getCustomHouseRules};
